import type { ReferenceDataField } from '@moment/trading-types/instrument-data'

import { isInstrumentClass } from '@moment/trading-types/reference-data'

/** A scalar Security value as SORM serializes it. */
export type SecurityValue = string | number | boolean | null | undefined

export interface ToInstrumentValueOptions {
  instrumentField: ReferenceDataField
  value: SecurityValue
  isDecimal: boolean
}

/** One Security value as the live-inventory field it serves. */
export function toInstrumentValue({
  instrumentField,
  value,
  isDecimal,
}: ToInstrumentValueOptions): SecurityValue {
  // Security's subtype also carries bond kinds; live inventory sets it only for equities and funds.
  if (instrumentField === 'instrument_class') {
    return isInstrumentClass(value?.toString()) ? value : null
  }
  return isDecimal && value != null ? Number(value) : value
}
